import React, { Component } from 'react'
import {
  Project,
  ResourcesById,
  ProjectStatus,
  ResourceInfo
} from '../../schema/types.d'
import { ProjectStatus as ProjectStatusLib } from './period'

interface EmployeeColumnProps {
  resource: ResourceInfo.Fragment
}
class EmployeeColumn extends Component<EmployeeColumnProps> {
  render() {
    return (
      <th className="lh-copy pa1 ph0-l br bb b--black-10 bw4" rowSpan={3}>
        <div className="dt w12">
          <div className="dtc v-mid">
            <img
              alt=""
              src={this.props.resource.thumbnailUrl}
              className="br-100 h3 w3 dib"
              title={`Photo of ${this.props.resource.fullName}`}
            />
          </div>
          <div className="dtc v-mid tc">
            <div className="f7 black-70">{this.props.resource.fullName}</div>
            <div className="f7 black-50">
              {this.props.resource.laborCategory}
            </div>
          </div>
        </div>
      </th>
    )
  }
}

interface ColumnHeaderProps {
  text: string
  phase: string[]
}
class ColumnHeader extends Component<ColumnHeaderProps> {
  render() {
    return (
      <th className="bb br b--black-10">
        <div className="nowrap pa2">{this.props.text}</div>
        <div className="w-100 dt">
          {this.props.phase
            ? this.props.phase.map((p, i) => (
                <div
                  key={i}
                  className={
                    'h2 bg-animate hide-child dtc color-' + p.slice(-1)
                  }
                >
                  {' '}
                  <span className="f7 white dtc child bg-black-40 h2">
                    {p.slice(0, -3)}
                  </span>
                </div>
              ))
            : null}
        </div>
      </th>
    )
  }
}

interface WorkPlannerProps extends ProjectStatus.Props {
  project: Project.Project
}

interface WorkPlannerState {
  days: number
  time_period: string
}

class WorkPlannerTable extends Component<WorkPlannerProps, WorkPlannerState> {
  TIMEPERIOD = {
    total_job: 'Total Job',
    job_to_date: 'Job to Date',
    year_to_date: 'Year to Date',
    current_year: 'Current Year',
    prior_year: 'Prior Year',
    trailing_12_months: 'Trailing 12 months',
    current_month: 'Current Month'
  }

  constructor(props: WorkPlannerProps) {
    super(props)
    this.state = {
      days: 90,
      time_period: this.TIMEPERIOD.total_job
    }
  }

  changeDays(event) {
    this.setState({
      days: parseInt(event.target.value)
    })
  }

  changeDates(event) {
    this.setState({
      time_period: event.target.value
    })
  }

  extractEmployees(labor: ProjectStatus.Labor[]): string[] {
    let emp = new Set()
    labor.map(l => emp.add(l.resource.id))
    return [...emp]
  }

  timePeriod(tp: string, startDate: Date, endDate: Date) {
    const today = new Date()
    switch (tp) {
      case this.TIMEPERIOD.current_month: {
        return {
          startDate: new Date(today.getFullYear(), today.getMonth(), 1),
          endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        }
      }
      case this.TIMEPERIOD.current_year:
        return {
          startDate: new Date(today.getFullYear(), 0, 1),
          endDate: new Date(today.getFullYear() + 1, 0, 0)
        }
      case this.TIMEPERIOD.job_to_date:
        return {
          startDate: startDate,
          endDate: today
        }
      case this.TIMEPERIOD.prior_year:
        return {
          startDate: new Date(today.getFullYear() - 1, 0, 1),
          endDate: new Date(today.getFullYear(), 0, 0)
        }
      case this.TIMEPERIOD.trailing_12_months:
        return {
          startDate: new Date(
            today.getFullYear(),
            today.getMonth() - 12,
            today.getDate()
          ),
          endDate: today
        }
      case this.TIMEPERIOD.year_to_date:
        return {
          startDate: new Date(today.getFullYear(), 0, 1),
          endDate: today
        }
      default:
        return {
          startDate: startDate,
          endDate: endDate
        }
    }
  }
  monthYearDisplay(d: Date, displayDay = true) {
    if (d) {
      let month = d.getMonth()
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      const monthName = months[month]
      const day = displayDay ? d.getDate() : ''
      return monthName ? day + ' ' + monthName + ' ' + d.getFullYear() : ''
    }
    return ''
  }

  render() {
    return (
      <ProjectStatus.Component
        variables={{ projectId: this.props.project.projectNumber }}
        fetchPolicy="no-cache"
      >
        {({ loading, error, data }) => {
          if (loading) return <div>Fetching</div>
          if (error) return <div>Error</div>
          if (!data) return <div>No data!</div>
          const project = data.project

          // TODO FIXME
          if (
            !project ||
            (!project.budget && !project.plan && project.labor.length <= 0)
          )
            return <div />

          let projectStatusLib = new ProjectStatusLib(project, this.state.days)
          const date_range = this.timePeriod(
            this.state.time_period,
            projectStatusLib.start,
            projectStatusLib.end
          )
          const start = date_range.startDate
          const end = date_range.endDate
          projectStatusLib.resetDates(start, end)
          const emp_ids = this.extractEmployees(project.labor)
          let l_timelines = projectStatusLib.labor_timeline_by_resources()
          let date_headers = projectStatusLib.dateHeaders()
          const phases = projectStatusLib.phase_timeline()
          let p_timelines = projectStatusLib.plan_timeline_by_resources()
          let b_timelines = projectStatusLib.budget_timeline_by_resources()

          return (
            <ResourcesById.Component variables={{ ids: emp_ids }}>
              {({ loading, error, data }) => {
                if (loading) return <div>Fetching</div>
                if (error) return <div>Error</div>
                if (!data) return <div>No data!</div>
                const resources = data.resources_by_id
                return (
                  <div className="bg-projects fr w-75 mt1 h-100">
                    <h4 className="pl4 thumbnail_title">Project Roadmap</h4>
                    <article className="work-planner b--black-10 h-100">
                      <div className="bb b--black-10">
                        <div className="f7 b black-50 pb2">
                          Time Period :
                          <select
                            className="pl2"
                            onChange={this.changeDates.bind(this)}
                            value={this.state.time_period}
                          >
                            <option value={this.TIMEPERIOD.total_job}>
                              {this.TIMEPERIOD.total_job}
                            </option>
                            <option value={this.TIMEPERIOD.job_to_date}>
                              {this.TIMEPERIOD.job_to_date}
                            </option>
                            <option value={this.TIMEPERIOD.current_month}>
                              {this.TIMEPERIOD.current_month}
                            </option>
                            <option value={this.TIMEPERIOD.current_year}>
                              {this.TIMEPERIOD.current_year}
                            </option>
                            <option value={this.TIMEPERIOD.trailing_12_months}>
                              {this.TIMEPERIOD.trailing_12_months}
                            </option>
                            <option value={this.TIMEPERIOD.year_to_date}>
                              {this.TIMEPERIOD.year_to_date}
                            </option>
                          </select>
                        </div>
                        <div className="f7 b black-50 pb2 fr">
                          Interval :
                          <select
                            className="pl2"
                            onChange={this.changeDays.bind(this)}
                            value={this.state.days}
                          >
                            <option value={7}>Weekly</option>
                            <option value={30}>Monthly</option>
                            <option value={90}>Quarterly</option>
                            <option value={365}>Yearly</option>
                          </select>
                        </div>
                        <div className="f7 b black-50 pt1 fl">
                          Date Range : {this.monthYearDisplay(start)} -{' '}
                          {this.monthYearDisplay(end)}
                        </div>
                      </div>
                      <div />
                      <div className="table-scroll relative overflow-auto">
                        <table className="w-100 center">
                          <thead>
                            <tr>
                              <th className="bb br b--black-10 tl pb3 pr3 bg-white thumbnail_title">
                                {'Total: ' + resources.length}
                              </th>
                              {date_headers.map((dt, index) => (
                                <ColumnHeader
                                  key={index}
                                  text={dt}
                                  phase={phases[index]}
                                />
                              ))}
                            </tr>
                          </thead>
                          {resources.map((r, r_index) => {
                            const l_t = l_timelines.get(r.id)
                            const p_t =
                              p_timelines.get(r.id) ||
                              new Array(l_t.length).fill([0, 0])
                            const b_t =
                              b_timelines.get(r.id) ||
                              new Array(l_t.length).fill([0, 0])
                            return (
                              <tbody className="lh-copy" key={r_index}>
                                <tr>
                                  <EmployeeColumn resource={r} />
                                  {l_t.map((s, l_index) => {
                                    let [rh, oh, soh] =
                                      s.length > 0
                                        ? [s[0], s[1], s[2]]
                                        : [0, 0, 0]
                                    let [plh, plc] =
                                      p_t[l_index].length > 0
                                        ? [p_t[l_index][0], p_t[l_index][1]]
                                        : [0, 0]
                                    let textColor =
                                      plh > rh
                                        ? 'green'
                                        : plh < rh
                                        ? 'red'
                                        : 'black-60'
                                    return (
                                      <td
                                        key={'labor_' + l_index}
                                        className={
                                          'ph0-l f6 bb br b--black-10 ' +
                                          textColor
                                        }
                                      >
                                        {rh ? rh : null}
                                      </td>
                                    )
                                  })}
                                </tr>
                                <tr>
                                  {p_t.map((s, p_index) => {
                                    let [lh, lc] =
                                      s.length > 0 ? [s[0], s[1]] : [0, 0]
                                    return (
                                      <td
                                        key={'plan_' + r_index + p_index}
                                        className="pt2 pb2 ph0-l f6 black-60 bb b--black-10"
                                      >
                                        {lh ? lh.toFixed(2) : null}
                                      </td>
                                    )
                                  })}
                                </tr>
                                <tr>
                                  {b_t.map((s, p_index) => {
                                    let [lh, lc] =
                                      s.length > 0 ? [s[0], s[1]] : [0, 0]
                                    return (
                                      <td
                                        key={'budget_' + r_index + p_index}
                                        className="pt2 pb2 ph0-l f6 black-60 bb b--black-10 bw4"
                                      >
                                        {lh ? lh.toFixed(2) : null}
                                      </td>
                                    )
                                  })}
                                </tr>
                              </tbody>
                            )
                          })}
                        </table>
                      </div>
                    </article>
                  </div>
                )
              }}
            </ResourcesById.Component>
          )
        }}
      </ProjectStatus.Component>
    )
  }
}

export default WorkPlannerTable
